import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import OafDetail from '../Oaf/OafDetail'
import FontProperty from './FontProperty'
import GoodDetailPageModel from './GoodDetailPageModel'
import Goods, { GoodsTypeEnum, GoodsStatus } from './Goods'
import Viewport from '../ComControl/Viewport'

export type Screen_hash = {
    Width: number
    Height: number
}
class GameMallNewModel {
    public Version: number = 3 // 数据版本
    public MallBack: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城/商城背景.png'}) // 商城背景图片
    public DecorateBack: FileName = new FileName({type: FileName.DEF_TYPE, name: ''}) // 装饰图层
    public Decorate_X: number = 733 // 装饰图层X坐标
    public Decorate_Y: number = 68 // 装饰图层Y坐标
    public IsUseOaf: boolean = false // 是否使用动图
    public OafDetailInfo: OafDetail = new OafDetail() // 动图信息
    public ClosePic: AvgButtonIndex = new AvgButtonIndex(39, 0, 0) // 关闭按钮图片
    public GoodDetailPage: GoodDetailPageModel = new GoodDetailPageModel() // 商品详情页信息
    public GoodAreaBack: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城_商品区域底板.png'}) // 商品区域底板图
    public IsShowGoodName: boolean = false // 是否显示商品名称
    public IsShowGoodIntro: boolean = false // 是否显示商品简介
    public IsShowGoodImage: boolean = false // 是否显示商品图片
    public GoodsList: Array<Goods> = [] // 商品列表
    public FlowerFont: FontProperty = new FontProperty('微软雅黑', 14, '255, 255, 255') // 剩余鲜花字体属性
    public FlowerPic: FileName = new FileName({type: FileName.DEF_TYPE, name: '商城_花.png'}) // 鲜花图片
    public Flower_X: number = 0 // 鲜花图片X坐标
    public Flower_Y: number = 0 // 鲜花图片Y坐标
    public FlowerOwn_X: number = 0 // 剩余鲜花X坐标
    public FlowerOwn_Y: number = 0 // 剩余鲜花Y坐标
    public FlowerPrice_X: number = 0 // 剩余鲜花数X坐标
    public FlowerPrice_Y: number = 0 // 剩余鲜花数Y坐标
    public GoodAreaBack_X: number = 0 // 商品区域底板X坐标
    public GoodAreaBack_Y: number = 0 // 商品区域底板Y坐标
    public GoodAreaBack_W: number = 0 // 商品区域底板宽度
    public GoodAreaBack_H: number = 0 // 商品区域底板高度
    public PrePic: AvgButtonIndex = new AvgButtonIndex(0, 0, 0) // 前翻按钮
    public NextPic: AvgButtonIndex = new AvgButtonIndex(0, 0, 0) // 后翻按钮
    public PageFont: FontProperty = new FontProperty('', 14, '') // 页码文字属性
    public PageX: number = 0 // 页码x偏移
    public PageY: number = 0 // 页码y偏移
    public TagButton: AvgButtonIndex = new AvgButtonIndex(0, 0, 0) // 标签按钮
    public TagName: string = '鲜花商城' // 标签名称
    public PublishTime: string = '0' // 发布时间
    public ModifyPosition: number = 0 // 修改来源 0=工具 1=个人中心
    public IsShowOneKeyGetBtn: boolean = true /// 是否显示一键领取按钮
    public OneKeyGetBtn: AvgButtonIndex = new AvgButtonIndex(0, 0, 0) /// 一键领取按钮
    public FontInfo = new FontProperty('微软雅黑', 20, '255,255,255')
    private FontColor_UI: string
    private Screen_hash: Screen_hash

    constructor(
        FontColor_UI: string = '255,255,255',
        Screen_hash: Screen_hash = { Width: 960, Height: 540 }
    ) {
        this.FontColor_UI = FontColor_UI
        this.Screen_hash = Screen_hash

        this.Decorate_X = this.GetDecorateBackX()
        this.Decorate_Y = this.GetDecorateBackY()
        this.ClosePic = new AvgButtonIndex(39, this.GetClosePicX(), this.GetClosePicY())
        this.FlowerFont = new FontProperty('微软雅黑', 14, FontColor_UI)

        this.FlowerOwn_X = this.GetRestX()
        this.FlowerOwn_Y = this.GetRestY()
        this.Flower_X = this.GetFlowerX()
        this.Flower_Y = this.GetFlowerY()
        this.FlowerPrice_X = this.GetRestNumX()
        this.FlowerPrice_Y = this.GetRestNumY()
        this.GoodDetailPage = this.GreateDetailPageModel()
        this.GoodAreaBack_X = this.GetGoodAreaBack_X()
        this.GoodAreaBack_Y = this.GetGoodAreaBack_Y()
        this.GoodAreaBack_W = this.GetGoodAreaBack_W()
        this.GoodAreaBack_H = this.GetGoodAreaBack_H()
        this.IsShowGoodName = true
        this.IsShowGoodImage = true
        this.GoodsList = this.CreateGoods()
        this.IsShowOneKeyGetBtn = true
        this.OneKeyGetBtn = new AvgButtonIndex(59, this.GetOneKeyGetBtnX(), this.GetOneKeyGetBtnY())
    }

    /// 获取一键领取按钮的X坐标
    private GetOneKeyGetBtnX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 80
        else if (screenW == 1280 && screenH == 720) return 80
        else if (screenW == 540 && screenH == 960) return 320
        return 0
    }
    private GetOneKeyGetBtnY() {
        /// 获取一键领取按钮的Y坐标
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 70
        else if (screenW == 1280 && screenH == 720) return 70
        else if (screenW == 540 && screenH == 960) return 830
        return 0
    }
    // 获取装饰图层的初始X坐标
    private GetDecorateBackX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 16
        else if (screenW === 1280 && screenH === 720) return 22
        else if (screenW === 800 && screenH === 600) return 75
        return 0
    }

    // 获取装饰图层的初始Y坐标
    private GetDecorateBackY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 698
        else if (screenW === 1280 && screenH === 720) return 937
        else if (screenW === 800 && screenH === 600) return 558
        return 0
    }

    // 获取关闭按钮的X坐标
    private GetClosePicX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 787
        else if (screenW === 1280 && screenH === 720) return 1049
        else if (screenW === 800 && screenH === 600) return 663
        else if (screenW === 540 && screenH === 960) return 459
        return 0
    }

    // 获取关闭按钮的Y坐标
    private GetClosePicY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 470
        else if (screenW === 1280 && screenH === 720) return 626
        else if (screenW === 800 && screenH === 600) return 504
        else if (screenW === 540 && screenH === 960) return 855
        return 0
    }

    // 剩余鲜花X坐标
    private GetRestX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 584
        else if (screenW === 1280 && screenH === 720) return 779
        else if (screenW === 540 && screenH === 960) return 322
        return 0
    }

    // 剩余鲜花Y坐标
    private GetRestY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 123
        else if (screenW === 1280 && screenH === 720) return 190
        else if (screenW === 540 && screenH === 960) return 187
        return 0
    }

    // 鲜花X坐标
    private GetFlowerX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 667
        else if (screenW === 1280 && screenH === 720) return 892
        else if (screenW === 540 && screenH === 960) return 407
        return 0
    }

    // 鲜花Y坐标
    private GetFlowerY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 121
        else if (screenW === 1280 && screenH === 720) return 190
        else if (screenW === 540 && screenH === 960) return 184
        return 0
    }

    // 剩余鲜花数量X坐标
    private GetRestNumX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 692
        else if (screenW === 1280 && screenH === 720) return 925
        else if (screenW === 540 && screenH === 960) return 432
        return 0
    }

    // 剩余鲜花数量Y坐标
    private GetRestNumY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 123
        else if (screenW === 1280 && screenH === 720) return 190
        else if (screenW === 540 && screenH === 960) return 184
        return 0
    }

    // 获取商品区域底板X坐标
    private GetGoodAreaBack_X() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 80
        else if (screenW === 1280 && screenH === 720) return 108
        else if (screenW === 540 && screenH === 960) return 70
        return 0
    }

    // 获取商品区域底板Y坐标
    private GetGoodAreaBack_Y() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 152
        else if (screenW === 1280 && screenH === 720) return 230
        else if (screenW === 540 && screenH === 960) return 212
        return 0
    }

    // 获取商品区域底板W
    private GetGoodAreaBack_W() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 646
        else if (screenW === 1280 && screenH === 720) return 864
        else if (screenW === 540 && screenH === 960) return 400
        return 0
    }

    // 获取商品区域底板H
    private GetGoodAreaBack_H() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 340
        else if (screenW === 1280 && screenH === 720) return 384
        else if (screenW === 540 && screenH === 960) return 612
        return 0
    }

    // 创建详情页数据
    public GreateDetailPageModel() {
        const detail = new GoodDetailPageModel()

        detail.PreviewBack_X = this.GetPreviewBackX()
        detail.PreviewBack_Y = this.GetPreviewBackY()
        detail.PreviewBack_W = this.GetPreviewBackW()
        detail.PreviewBack_H = this.GetPreviewBackH()
        detail.Preview_X = this.GetPreviewX()
        detail.Preview_Y = this.GetPreviewY()
        detail.Preview_W = this.GetPreviewW()
        detail.Preview_H = this.GetPreviewH()
        detail.GoodName_X = this.GetGoodNameX()
        detail.GoodName_Y = this.GetGoodNameY()
        detail.FlowerTotal_X = this.GetFlowerTotalX()
        detail.FlowerTotal_Y = this.GetFlowerTotalY()
        detail.Flower_X = this.GetGoodFlowerX()
        detail.Flower_Y = this.GetGoodFlowerY()
        detail.GoodPrice_X = this.GetGoodPriceX()
        detail.GoodPrice_Y = this.GetGoodPriceY()
        detail.GoodIntroView = this.GetGoodIntroView()
        detail.Ok_btn = new AvgButtonIndex(40, this.GetOKBtnX(), this.GetOKBtnY())
        detail.Cancel_btn = new AvgButtonIndex(41, this.GetCancelBtnX(), this.GetCancelBtnY())
        detail.Add_btn = new AvgButtonIndex(45, this.GetAddBtnX(), this.GetAddBtnY())
        detail.Minus_btn = new AvgButtonIndex(46, this.GetMinBtnX(), this.GetMinBtnY())
        detail.BuyCount_X = this.GetBuyCountX()
        detail.BuyCount_Y = this.GetBuyCountY()

        return detail
    }

    public ResetDetailPageModel(goodDetailPageModel: GoodDetailPageModel) {
        goodDetailPageModel.PreviewBack_X = this.GetPreviewBackX()
        goodDetailPageModel.PreviewBack_Y = this.GetPreviewBackY()
        goodDetailPageModel.PreviewBack_W = this.GetPreviewBackW()
        goodDetailPageModel.PreviewBack_H = this.GetPreviewBackH()
        goodDetailPageModel.Preview_X = this.GetPreviewX()
        goodDetailPageModel.Preview_Y = this.GetPreviewY()
        goodDetailPageModel.Preview_W = this.GetPreviewW()
        goodDetailPageModel.Preview_H = this.GetPreviewH()
        goodDetailPageModel.GoodName_X = this.GetGoodNameX()
        goodDetailPageModel.GoodName_Y = this.GetGoodNameY()
        goodDetailPageModel.FlowerTotal_X = this.GetFlowerTotalX()
        goodDetailPageModel.FlowerTotal_Y = this.GetFlowerTotalY()
        goodDetailPageModel.Flower_X = this.GetGoodFlowerX()
        goodDetailPageModel.Flower_Y = this.GetGoodFlowerY()
        goodDetailPageModel.GoodPrice_X = this.GetGoodPriceX()
        goodDetailPageModel.GoodPrice_Y = this.GetGoodPriceY()
        goodDetailPageModel.GoodIntroView = this.GetGoodIntroView()
        goodDetailPageModel.Ok_btn.X = this.GetOKBtnX()
        goodDetailPageModel.Ok_btn.Y = this.GetOKBtnY()
        goodDetailPageModel.Cancel_btn.X = this.GetCancelBtnX()
        goodDetailPageModel.Cancel_btn.Y = this.GetCancelBtnY()
        goodDetailPageModel.Add_btn.X = this.GetAddBtnX()
        goodDetailPageModel.Add_btn.Y = this.GetAddBtnY()
        goodDetailPageModel.Minus_btn.X = this.GetMinBtnX()
        goodDetailPageModel.Minus_btn.Y = this.GetMinBtnY()
        goodDetailPageModel.BuyCount_X = this.GetBuyCountX()
        goodDetailPageModel.BuyCount_Y = this.GetBuyCountY()
    }

    // 创建商品
    private CreateGoods() {
        const list: Goods[] = []
        const count = 6
        // this.GoodListLen = 7
        for (let i = 0; i < count; i++) {
            const index = i + 1
            const goods = new Goods()

            goods.GoodsId = index
            goods.GoodsName = GameMallNewModel.GetGoodsName(index)
            goods.GoodsType = GameMallNewModel.GetGoodsType(index)
            goods.GoodsPrice = GameMallNewModel.GetGoodPrice(index)
            goods.GoodsIntro = GameMallNewModel.GetGoodIntro(index)
            goods.GoodsFont = new FontProperty('微软雅黑', 21, this.FontColor_UI)
            goods.GoodsPriceFont = new FontProperty('微软雅黑', 18, this.FontColor_UI)
            goods.GoodsIntroFont = new FontProperty('微软雅黑', 18, this.FontColor_UI)
            goods.Preview = new FileName({type: FileName.DEF_TYPE, name: GameMallNewModel.GetGoodsPic(index)})
            goods.BuyBtn = new AvgButtonIndex(42, 0, 0)
            goods.Good_Status = GameMallNewModel.GetGoodState(index)

            goods.IsUnlockSpirit = GameMallNewModel.GetIsUnlockSpirit(goods.GoodsType)
            goods.IsFreeWithTime = GameMallNewModel.GetIsFree(goods.GoodsType)
            goods.GoodProperty = GameMallNewModel.GetGoodProperty(index)
            GameMallNewModel.SetGoodsLocation(goods, count, index, this.Screen_hash)

            list.push(goods)
        }

        return list
    }

    // 根据索引值获取商品名称
    private static GetGoodsName(num: number) {
        let name = ''
        switch (num) {
            case 1:
                name = '超级大礼包'
                break
            case 2:
                name = '主线剧情'
                break
            case 3:
                name = '番外合集'
                break
            case 4:
                name = '属性优化'
                break
            case 5:
                name = '上帝视角'
                break
            case 6:
                name = '快捷通道'
                break
            default:
                name = '预售新品'
                break
        }
        return name
    }

    // 根据索引值获取商品类型
    private static GetGoodsType(index: number) {
        if (index === 1) return GoodsTypeEnum.MaxPack
        else if (index === 4) return GoodsTypeEnum.Var
        else return GoodsTypeEnum.Map
    }

    // 获取商品的价格
    private static GetGoodPrice(num: number) {
        return num === 1 ? 25 : 10
    }

    // 获取商品简介
    private static GetGoodIntro(index: number) {
        let Des = ''
        switch (index) {
            case 1:
                Des = '超级大礼包，内含所有商品，半价优惠，经济实惠！'
                break
            case 2:
                Des = '开启后续主线剧情，故事如何发展，全凭你来定夺。'
                break
            case 3:
                Des = '男神的番外日常，与男神近距离接触。'
                break
            case 4:
                Des = '开启金手指，所有属性值加满哦~'
                break
            case 5:
                Des = '购买后开启上帝视角，看看他们背着你做了什么？'
                break
            case 6:
                Des = '购买后可以从任意节点开始，再也不用担心存档丢失啦！'
                break
            default:
                Des = ''
                break
        }
        return Des
    }

    // 根据商品索引获取显示图的名称
    private static GetGoodsPic(index: number) {
        let pic = ''
        switch (index) {
            case 1:
                pic = '商品图片_超级大礼包.png'
                break
            case 2:
                pic = '商品图片_主线剧情.png'
                break
            case 3:
                pic = '商品图片_番外合集.png'
                break
            case 4:
                pic = '商品图片_上帝视角.png'
                break
            case 5:
                pic = '商品图片_属性优化.png'
                break
            case 6:
                pic = '商品图片_快捷通道.png'
                break
            default:
                pic = '商品图片_新.png'
                break
        }
        return pic
    }

    // 获取商品状态，默认是未上架2
    private static GetGoodState(num: number) {
        return num === 1 ? GoodsStatus.IsUp : GoodsStatus.NotUp
    }

    // 返回是否解体力锁
    private static GetIsUnlockSpirit(type: GoodsTypeEnum) {
        return GoodsTypeEnum.MaxPack === type
    }

    // 返回商品是否限免，目前一直返回false
    private static GetIsFree(type: GoodsTypeEnum) {
        return false
    }

    // 获得商品的属性值
    private static GetGoodProperty(num: number) {
        return num === 1 ? '2,3,4,5,6' : ''
    }

    // 根据商品数量更新默认位置
    private static SetGoodsLocation(
        goodsDetail: Goods,
        count: number,
        index: number,
        Screen_hash: Screen_hash
    ) {
        const screenW = Screen_hash.Width
        const screenH = Screen_hash.Height

        if (screenW === 960 && screenH === 540) {
            if (count === 1) {
                // 960*540  count=1  index=1
                goodsDetail.GoodsBack_X = 80
                goodsDetail.GoodsBack_Y = 172
                goodsDetail.GoodsBack_W = 648
                goodsDetail.GoodsBack_H = 280
                goodsDetail.Preview_W = 160
                goodsDetail.Preview_H = 160
                goodsDetail.Preview_X = 244
                goodsDetail.Preview_Y = 24
                goodsDetail.GoodsName_X = 21
                goodsDetail.GoodsName_Y = 229
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 640
                goodsDetail.PreviewBack_H = 200
                goodsDetail.Flower_X = 179
                goodsDetail.Flower_Y = 230
                goodsDetail.GoodsPrice_X = 205
                goodsDetail.GoodsPrice_Y = 231
                goodsDetail.BuyBtn.X = 536
                goodsDetail.BuyBtn.Y = 222
            } else if (count === 2) {
                // 960*540  count=2
                if (index === 1) {
                    // 960*540  count=2  index=1
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 172
                }
                if (index === 2) {
                    // 960*540  count=2  index=2
                    goodsDetail.GoodsBack_X = 412
                    goodsDetail.GoodsBack_Y = 172
                }
                goodsDetail.GoodsBack_W = 316
                goodsDetail.GoodsBack_H = 280
                goodsDetail.Preview_W = 144
                goodsDetail.Preview_H = 144
                goodsDetail.Preview_X = 86
                goodsDetail.Preview_Y = 18
                goodsDetail.GoodsName_X = 25
                goodsDetail.GoodsName_Y = 196
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 308
                goodsDetail.PreviewBack_H = 172
                goodsDetail.Flower_X = 25
                goodsDetail.Flower_Y = 237
                goodsDetail.GoodsPrice_X = 48
                goodsDetail.GoodsPrice_Y = 238
                goodsDetail.BuyBtn.X = 204
                goodsDetail.BuyBtn.Y = 226
            } else if (count === 3) {
                // 960*540 count=3
                if (index === 1) {
                    // 960*540  count=3  index=1
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 172
                }
                if (index === 2) {
                    // 960*540  count=3  index=2
                    goodsDetail.GoodsBack_X = 304
                    goodsDetail.GoodsBack_Y = 172
                }
                if (index === 3) {
                    // 960*540  count=3  index=3
                    goodsDetail.GoodsBack_X = 528
                    goodsDetail.GoodsBack_Y = 172
                }
                goodsDetail.GoodsBack_W = 200
                goodsDetail.GoodsBack_H = 280
                goodsDetail.Preview_W = 88
                goodsDetail.Preview_H = 88
                goodsDetail.Preview_X = 56
                goodsDetail.Preview_Y = 20
                goodsDetail.GoodsName_X = 22
                goodsDetail.GoodsName_Y = 145
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 192
                goodsDetail.PreviewBack_H = 120
                goodsDetail.Flower_X = 22
                goodsDetail.Flower_Y = 181
                goodsDetail.GoodsPrice_X = 45
                goodsDetail.GoodsPrice_Y = 182
                goodsDetail.BuyBtn.X = 56
                goodsDetail.BuyBtn.Y = 222
            } else if (count === 4) {
                // 960*540 count=4
                if (index === 1) {
                    // 960*540  count=4  index=1
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 172
                }
                if (index === 2) {
                    // 960*540  count=4  index=2
                    goodsDetail.GoodsBack_X = 412
                    goodsDetail.GoodsBack_Y = 172
                }
                if (index === 3) {
                    // 960*540  count=4  index=3
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 320
                }
                if (index === 4) {
                    // 960*540  count=4  index=4
                    goodsDetail.GoodsBack_X = 412
                    goodsDetail.GoodsBack_Y = 320
                }
                goodsDetail.GoodsBack_W = 316
                goodsDetail.GoodsBack_H = 132
                goodsDetail.Preview_W = 88
                goodsDetail.Preview_H = 88
                goodsDetail.Preview_X = 14
                goodsDetail.Preview_Y = 22
                goodsDetail.GoodsName_X = 130
                goodsDetail.GoodsName_Y = 28
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 108
                goodsDetail.PreviewBack_H = 124
                goodsDetail.Flower_X = 130
                goodsDetail.Flower_Y = 81
                goodsDetail.GoodsPrice_X = 153
                goodsDetail.GoodsPrice_Y = 82
                goodsDetail.BuyBtn.X = 206
                goodsDetail.BuyBtn.Y = 71
            } else if (count === 5 || count === 6) {
                // 960*540 count=5,6
                if (index === 1) {
                    // 960*540  count=5,6  index=1
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 152
                }
                if (index === 2) {
                    // 960*540  count=5,6  index=2
                    goodsDetail.GoodsBack_X = 410
                    goodsDetail.GoodsBack_Y = 152
                }
                if (index === 3) {
                    // 960*540  count=5,6  index=3
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 270
                }
                if (index === 4) {
                    // 960*540  count=5,6  index=4
                    goodsDetail.GoodsBack_X = 410
                    goodsDetail.GoodsBack_Y = 270
                }
                if (index === 5) {
                    // 960*540  count=5,6  index=5
                    goodsDetail.GoodsBack_X = 80
                    goodsDetail.GoodsBack_Y = 388
                }
                if (index === 6) {
                    // 960*540  count=5,6  index=6
                    goodsDetail.GoodsBack_X = 410
                    goodsDetail.GoodsBack_Y = 388
                }
                goodsDetail.GoodsBack_W = 316
                goodsDetail.GoodsBack_H = 104
                goodsDetail.Preview_W = 72
                goodsDetail.Preview_H = 72
                goodsDetail.Preview_X = 16
                goodsDetail.Preview_Y = 16
                goodsDetail.GoodsName_X = 115
                goodsDetail.GoodsName_Y = 22
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 96
                goodsDetail.PreviewBack_H = 96
                goodsDetail.Flower_X = 118
                goodsDetail.Flower_Y = 64
                goodsDetail.GoodsPrice_X = 139
                goodsDetail.GoodsPrice_Y = 65
                goodsDetail.BuyBtn.X = 210
                goodsDetail.BuyBtn.Y = 53
            } else {
                // 大于6个的商品求余取位
                const tag = index % 6
                switch (tag) {
                    case 1:
                        goodsDetail.GoodsBack_X = 80
                        goodsDetail.GoodsBack_Y = 152
                        break
                    case 2:
                        goodsDetail.GoodsBack_X = 410
                        goodsDetail.GoodsBack_Y = 152
                        break
                    case 3:
                        goodsDetail.GoodsBack_X = 80
                        goodsDetail.GoodsBack_Y = 270
                        break
                    case 4:
                        goodsDetail.GoodsBack_X = 410
                        goodsDetail.GoodsBack_Y = 270
                        break
                    case 5:
                        goodsDetail.GoodsBack_X = 80
                        goodsDetail.GoodsBack_Y = 388
                        break
                    case 0:
                        goodsDetail.GoodsBack_X = 410
                        goodsDetail.GoodsBack_Y = 388
                        break
                }
                goodsDetail.GoodsBack_W = 316
                goodsDetail.GoodsBack_H = 104
                goodsDetail.Preview_W = 72
                goodsDetail.Preview_H = 72
                goodsDetail.Preview_X = 16
                goodsDetail.Preview_Y = 16
                goodsDetail.GoodsName_X = 115
                goodsDetail.GoodsName_Y = 22
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 96
                goodsDetail.PreviewBack_H = 96
                goodsDetail.Flower_X = 118
                goodsDetail.Flower_Y = 64
                goodsDetail.GoodsPrice_X = 139
                goodsDetail.GoodsPrice_Y = 65
                goodsDetail.BuyBtn.X = 210
                goodsDetail.BuyBtn.Y = 53
            }
        } else if (screenW == 1280 && screenH == 720) {
            if (count == 1) {
                // 1280*720  count=1  index=1
                goodsDetail.GoodsBack_X = 108
                goodsDetail.GoodsBack_Y = 230
                goodsDetail.GoodsBack_W = 864
                goodsDetail.GoodsBack_H = 384
                goodsDetail.Preview_W = 220
                goodsDetail.Preview_H = 220
                goodsDetail.Preview_X = 322
                goodsDetail.Preview_Y = 24
                goodsDetail.GoodsName_X = 30
                goodsDetail.GoodsName_Y = 307
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 856
                goodsDetail.PreviewBack_H = 260
                goodsDetail.Flower_X = 240
                goodsDetail.Flower_Y = 307
                goodsDetail.GoodsPrice_X = 275
                goodsDetail.GoodsPrice_Y = 310
                goodsDetail.BuyBtn.X = 714
                goodsDetail.BuyBtn.Y = 299
            } else if (count == 2) {
                // 1280*720  count=2
                if (index == 1) {
                    // 1280*720  count=2  index=1
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 2) {
                    // 1280*720  count=2  index=2
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 230
                }
                goodsDetail.GoodsBack_W = 420
                goodsDetail.GoodsBack_H = 384
                goodsDetail.Preview_W = 192
                goodsDetail.Preview_H = 192
                goodsDetail.Preview_X = 114
                goodsDetail.Preview_Y = 28
                goodsDetail.GoodsName_X = 33
                goodsDetail.GoodsName_Y = 272
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 412
                goodsDetail.PreviewBack_H = 240
                goodsDetail.Flower_X = 33
                goodsDetail.Flower_Y = 317
                goodsDetail.GoodsPrice_X = 65
                goodsDetail.GoodsPrice_Y = 319
                goodsDetail.BuyBtn.X = 270
                goodsDetail.BuyBtn.Y = 306
            } else if (count == 3) {
                // 1280*720 count=3
                if (index == 1) {
                    // 1280*720  count=3  index=1
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 2) {
                    // 1280*720  count=3  index=2
                    goodsDetail.GoodsBack_X = 404
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 3) {
                    // 1280*720  count=3  index=3
                    goodsDetail.GoodsBack_X = 700
                    goodsDetail.GoodsBack_Y = 230
                }
                goodsDetail.GoodsBack_W = 272
                goodsDetail.GoodsBack_H = 384
                goodsDetail.Preview_W = 120
                goodsDetail.Preview_H = 120
                goodsDetail.Preview_X = 76
                goodsDetail.Preview_Y = 32
                goodsDetail.GoodsName_X = 29
                goodsDetail.GoodsName_Y = 211
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 264
                goodsDetail.PreviewBack_H = 176
                goodsDetail.Flower_X = 29
                goodsDetail.Flower_Y = 262
                goodsDetail.GoodsPrice_X = 61
                goodsDetail.GoodsPrice_Y = 263
                goodsDetail.BuyBtn.X = 76
                goodsDetail.BuyBtn.Y = 307
            } else if (count == 4) {
                // 1280*720 count=4
                if (index == 1) {
                    // 1280*720  count=4  index=1
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 2) {
                    // 1280*720  count=4  index=2
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 3) {
                    // 1280*720  count=4  index=3
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 430
                }
                if (index == 4) {
                    // 1280*720  count=4  index=4
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 430
                }
                goodsDetail.GoodsBack_W = 420
                goodsDetail.GoodsBack_H = 184
                goodsDetail.Preview_W = 120
                goodsDetail.Preview_H = 120
                goodsDetail.Preview_X = 16
                goodsDetail.Preview_Y = 32
                goodsDetail.GoodsName_X = 177
                goodsDetail.GoodsName_Y = 44
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 144
                goodsDetail.PreviewBack_H = 176
                goodsDetail.Flower_X = 176
                goodsDetail.Flower_Y = 107
                goodsDetail.GoodsPrice_X = 207
                goodsDetail.GoodsPrice_Y = 108
                goodsDetail.BuyBtn.X = 280
                goodsDetail.BuyBtn.Y = 96
            } else if (count == 5 || count == 6) {
                // 1280*720 count=5,6
                if (index == 1) {
                    // 1280*720  count=5,6  index=1
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 2) {
                    // 1280*720  count=5,6  index=2
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 230
                }
                if (index == 3) {
                    // 1280*720  count=5,6  index=3
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 362
                }
                if (index == 4) {
                    // 1280*720  count=5,6  index=4
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 362
                }
                if (index == 5) {
                    // 1280*720  count=5,6  index=5
                    goodsDetail.GoodsBack_X = 108
                    goodsDetail.GoodsBack_Y = 494
                }
                if (index == 6) {
                    // 1280*720  count=5,6  index=6
                    goodsDetail.GoodsBack_X = 552
                    goodsDetail.GoodsBack_Y = 494
                }
                goodsDetail.GoodsBack_W = 420
                goodsDetail.GoodsBack_H = 120
                goodsDetail.Preview_W = 88
                goodsDetail.Preview_H = 88
                goodsDetail.Preview_X = 22
                goodsDetail.Preview_Y = 16
                goodsDetail.GoodsName_X = 147
                goodsDetail.GoodsName_Y = 23
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 124
                goodsDetail.PreviewBack_H = 112
                goodsDetail.Flower_X = 148
                goodsDetail.Flower_Y = 69
                goodsDetail.GoodsPrice_X = 179
                goodsDetail.GoodsPrice_Y = 71
                goodsDetail.BuyBtn.X = 286
                goodsDetail.BuyBtn.Y = 58
            } else {
                // 大于6个的商品求余取位
                let tag = index % 6

                switch (tag) {
                    case 1:
                        goodsDetail.GoodsBack_X = 108
                        goodsDetail.GoodsBack_Y = 230
                        break
                    case 2:
                        goodsDetail.GoodsBack_X = 552
                        goodsDetail.GoodsBack_Y = 230
                        break
                    case 3:
                        goodsDetail.GoodsBack_X = 108
                        goodsDetail.GoodsBack_Y = 362
                        break
                    case 4:
                        goodsDetail.GoodsBack_X = 552
                        goodsDetail.GoodsBack_Y = 362
                        break
                    case 5:
                        goodsDetail.GoodsBack_X = 108
                        goodsDetail.GoodsBack_Y = 494
                        break
                    case 0:
                        goodsDetail.GoodsBack_X = 552
                        goodsDetail.GoodsBack_Y = 494
                        break
                }

                goodsDetail.GoodsBack_W = 420
                goodsDetail.GoodsBack_H = 120
                goodsDetail.Preview_W = 88
                goodsDetail.Preview_H = 88
                goodsDetail.Preview_X = 22
                goodsDetail.Preview_Y = 16
                goodsDetail.GoodsName_X = 147
                goodsDetail.GoodsName_Y = 23
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 124
                goodsDetail.PreviewBack_H = 112
                goodsDetail.Flower_X = 148
                goodsDetail.Flower_Y = 69
                goodsDetail.GoodsPrice_X = 179
                goodsDetail.GoodsPrice_Y = 71
                goodsDetail.BuyBtn.X = 286
                goodsDetail.BuyBtn.Y = 58
            }
        } else if (screenW == 540 && screenH == 960) {
            if (count == 1) {
                // 540*960  count=1  index=1
                goodsDetail.GoodsBack_X = 70
                goodsDetail.GoodsBack_Y = 212
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 608
                goodsDetail.Preview_X = 50
                goodsDetail.Preview_Y = 50
                goodsDetail.Preview_W = 300
                goodsDetail.Preview_H = 300
                goodsDetail.GoodsName_X = 139
                goodsDetail.GoodsName_Y = 427
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 392
                goodsDetail.PreviewBack_H = 392
                goodsDetail.Flower_X = 175
                goodsDetail.Flower_Y = 465
                goodsDetail.GoodsPrice_X = 198
                goodsDetail.GoodsPrice_Y = 466
                goodsDetail.BuyBtn.X = 154
                goodsDetail.BuyBtn.Y = 540
            } else if (count == 2) {
                // 540*960  count=2
                if (index == 1) {
                    // 540*960  count=2  index=1
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 212
                }
                if (index == 2) {
                    // 540*960  count=2  index=2
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 524
                }
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 296
                goodsDetail.Preview_X = 128
                goodsDetail.Preview_Y = 26
                goodsDetail.Preview_W = 144
                goodsDetail.Preview_H = 144
                goodsDetail.GoodsName_X = 21
                goodsDetail.GoodsName_Y = 208
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 392
                goodsDetail.PreviewBack_H = 188
                goodsDetail.Flower_X = 20
                goodsDetail.Flower_Y = 245
                goodsDetail.GoodsPrice_X = 43
                goodsDetail.GoodsPrice_Y = 246
                goodsDetail.BuyBtn.X = 288
                goodsDetail.BuyBtn.Y = 238
            } else if (count == 3) {
                // 540*960 count=3
                if (index == 1) {
                    // 540*960  count=3  index=1
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 212
                }
                if (index == 2) {
                    // 540*960  count=3  index=2
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 420
                }
                if (index == 3) {
                    // 540*960  count=3  index=3
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 628
                }
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 192
                goodsDetail.Preview_X = 28
                goodsDetail.Preview_Y = 36
                goodsDetail.Preview_W = 120
                goodsDetail.Preview_H = 120
                goodsDetail.GoodsName_X = 196
                goodsDetail.GoodsName_Y = 36
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 168
                goodsDetail.PreviewBack_H = 184
                goodsDetail.Flower_X = 196
                goodsDetail.Flower_Y = 82
                goodsDetail.GoodsPrice_X = 218
                goodsDetail.GoodsPrice_Y = 83
                goodsDetail.BuyBtn.X = 278
                goodsDetail.BuyBtn.Y = 108
            } else if (count == 4) {
                // 540*960 count=4
                if (index == 1) {
                    // 540*960  count=4  index=1
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 212
                }
                if (index == 2) {
                    // 540*960  count=4  index=2
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 368
                }
                if (index == 3) {
                    // 540*960  count=4  index=3
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 524
                }
                if (index == 4) {
                    // 540*960 count=4  index=4
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 680
                }
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 140
                goodsDetail.Preview_X = 26
                goodsDetail.Preview_Y = 26
                goodsDetail.Preview_W = 88
                goodsDetail.Preview_H = 88
                goodsDetail.GoodsName_X = 155
                goodsDetail.GoodsName_Y = 37
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 132
                goodsDetail.PreviewBack_H = 132
                goodsDetail.Flower_X = 154
                goodsDetail.Flower_Y = 89
                goodsDetail.GoodsPrice_X = 177
                goodsDetail.GoodsPrice_Y = 90
                goodsDetail.BuyBtn.X = 288
                goodsDetail.BuyBtn.Y = 81
            } else if (count == 5) {
                // 540*960 count=5
                if (index == 1) {
                    // 540*960  count=5  index=1
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 212
                }
                if (index == 2) {
                    // 540*960 count=5  index=2
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 336
                }
                if (index == 3) {
                    // 540*960  count=5  index=3
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 461
                }
                if (index == 4) {
                    // 540*960  count=5  index=4
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 586
                }
                if (index == 5) {
                    // 540*960  count=5  index=5
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 711
                }
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 108
                goodsDetail.Preview_X = 34
                goodsDetail.Preview_Y = 18
                goodsDetail.Preview_W = 72
                goodsDetail.Preview_H = 72
                goodsDetail.GoodsName_X = 155
                goodsDetail.GoodsName_Y = 23
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 132
                goodsDetail.PreviewBack_H = 100
                goodsDetail.Flower_X = 154
                goodsDetail.Flower_Y = 61
                goodsDetail.GoodsPrice_X = 177
                goodsDetail.GoodsPrice_Y = 62
                goodsDetail.BuyBtn.X = 288
                goodsDetail.BuyBtn.Y = 50
            } else if (count == 6) {
                // 540*960 count=6
                if (index == 1) {
                    // 540*960  count=6  index=1
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 212
                }
                if (index == 2) {
                    // 540*960 count=6  index=2
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 316
                }
                if (index == 3) {
                    // 540*960  count=6  index=3
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 420
                }
                if (index == 4) {
                    // 540*960  count=6  index=4
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 524
                }
                if (index == 5) {
                    // 540*960  count=6  index=5
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 628
                }
                if (index == 6) {
                    // 540*960  count=6  index=6
                    goodsDetail.GoodsBack_X = 70
                    goodsDetail.GoodsBack_Y = 732
                }
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 92
                goodsDetail.Preview_X = 13
                goodsDetail.Preview_Y = 10
                goodsDetail.Preview_W = 72
                goodsDetail.Preview_H = 72
                goodsDetail.GoodsName_X = 114
                goodsDetail.GoodsName_Y = 16
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 90
                goodsDetail.PreviewBack_H = 84
                goodsDetail.Flower_X = 115
                goodsDetail.Flower_Y = 50
                goodsDetail.GoodsPrice_X = 136
                goodsDetail.GoodsPrice_Y = 51
                goodsDetail.BuyBtn.X = 292
                goodsDetail.BuyBtn.Y = 36
            } else {
                // 大于6个的商品求余取位
                let tag = index % 6

                switch (tag) {
                    case 1:
                        goodsDetail.GoodsBack_Y = 212
                        break
                    case 2:
                        goodsDetail.GoodsBack_Y = 316
                        break
                    case 3:
                        goodsDetail.GoodsBack_Y = 420
                        break
                    case 4:
                        goodsDetail.GoodsBack_Y = 524
                        break
                    case 5:
                        goodsDetail.GoodsBack_Y = 628
                        break
                    case 0:
                        goodsDetail.GoodsBack_Y = 732
                        break
                }

                goodsDetail.GoodsBack_X = 70
                goodsDetail.GoodsBack_W = 400
                goodsDetail.GoodsBack_H = 92
                goodsDetail.Preview_X = 13
                goodsDetail.Preview_Y = 10
                goodsDetail.Preview_W = 72
                goodsDetail.Preview_H = 72
                goodsDetail.GoodsName_X = 114
                goodsDetail.GoodsName_Y = 16
                goodsDetail.PreviewBack_X = 4
                goodsDetail.PreviewBack_Y = 4
                goodsDetail.PreviewBack_W = 90
                goodsDetail.PreviewBack_H = 84
                goodsDetail.Flower_X = 115
                goodsDetail.Flower_Y = 50
                goodsDetail.GoodsPrice_X = 136
                goodsDetail.GoodsPrice_Y = 51
                goodsDetail.BuyBtn.X = 292
                goodsDetail.BuyBtn.Y = 36
            }
        }
    }

    // 获取预览图底板X坐标
    private GetPreviewBackX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 62
        else if (screenW === 1280 && screenH === 720) return 82
        else if (screenW === 540 && screenH === 960) return 178
        return 0
    }

    // 获取预览图底板Y坐标
    private GetPreviewBackY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 155
        else if (screenW === 1280 && screenH === 720) return 206
        else if (screenW === 540 && screenH === 960) return 217
        return 0
    }
    // 获取预览图底板W
    private GetPreviewBackW() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 174
        else if (screenW === 1280 && screenH === 720) return 233
        else if (screenW === 540 && screenH === 960) return 175
        return 0
    }

    // 获取预览图底板H
    private GetPreviewBackH() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 182
        else if (screenW === 1280 && screenH === 720) return 244
        else if (screenW === 540 && screenH === 960) return 183
        return 0
    }

    // 获取预览图X坐标
    private GetPreviewX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 87
        else if (screenW === 1280 && screenH === 720) return 116
        else if (screenW === 540 && screenH === 960) return 204
        return 0
    }

    // 获取预览图Y坐标
    private GetPreviewY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 184
        else if (screenW === 1280 && screenH === 720) return 245
        else if (screenW === 540 && screenH === 960) return 247
        return 0
    }
    // 获取预览图w
    private GetPreviewW() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 123
        else if (screenW === 1280 && screenH === 720) return 164
        else if (screenW === 540 && screenH === 960) return 123
        return 0
    }

    // 获取预览图H
    private GetPreviewH() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 123
        else if (screenW === 1280 && screenH === 720) return 164
        else if (screenW === 540 && screenH === 960) return 123
        return 0
    }

    // 获取商品名称X坐标
    private GetGoodNameX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 420
        else if (screenW === 1280 && screenH === 720) return 561
        else if (screenW === 540 && screenH === 960) return 207
        return 0
    }

    // 获取商品名称Y坐标
    private GetGoodNameY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 162
        else if (screenW === 1280 && screenH === 720) return 217
        else if (screenW === 540 && screenH === 960) return 412
        return 0
    }

    // 获取商品详情价格总共字符串的X坐标
    private GetFlowerTotalX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 562
        else if (screenW === 1280 && screenH === 720) return 750
        else if (screenW === 540 && screenH === 960) return 358
        return 0
    }

    // 获取商品详情价格总共字符串的Y坐标
    private GetFlowerTotalY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 288
        else if (screenW === 1280 && screenH === 720) return 384
        else if (screenW === 540 && screenH === 960) return 534
        return 0
    }

    // 获取商品详情价格鲜花X坐标
    private GetGoodFlowerX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 622
        else if (screenW === 1280 && screenH === 720) return 810
        else if (screenW === 540 && screenH === 960) return 417
        return 0
    }

    // 获取商品详情价格鲜花Y坐标
    private GetGoodFlowerY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 286
        else if (screenW === 1280 && screenH === 720) return 381
        else if (screenW === 540 && screenH === 960) return 532
        return 0
    }

    // 获取商品价格X坐标
    private GetGoodPriceX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 642
        else if (screenW === 1280 && screenH === 720) return 835
        else if (screenW === 540 && screenH === 960) return 442
        return 0
    }

    // 获取商品价格Y坐标
    private GetGoodPriceY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 288
        else if (screenW === 1280 && screenH === 720) return 384
        else if (screenW === 540 && screenH === 960) return 534
        return 0
    }

    // 获取商品简介尺寸
    private GetGoodIntroView() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return new Viewport(288, 203, 379, 36)
        else if (screenW === 1280 && screenH === 720) return new Viewport(384, 271, 505, 48)
        else if (screenW === 540 && screenH === 960) return new Viewport(75, 453, 379, 36)
        return new Viewport(0, 0, 0, 0)
    }

    // 获取确定按钮的位置X
    private GetOKBtnX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 492
        else if (screenW === 1280 && screenH === 720) return 657
        else if (screenW === 540 && screenH === 960) return 284
        return 0
    }

    // 获取确定按钮的位置Y
    private GetOKBtnY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 335
        else if (screenW === 1280 && screenH === 720) return 448
        else if (screenW === 540 && screenH === 960) return 602
        return 0
    }

    // 获取取消按钮的位置X
    private GetCancelBtnX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 311
        else if (screenW === 1280 && screenH === 720) return 416
        else if (screenW === 540 && screenH === 960) return 103
        return 0
    }

    // 获取取消按钮的位置Y
    private GetCancelBtnY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 335
        else if (screenW === 1280 && screenH === 720) return 448
        else if (screenW === 540 && screenH === 960) return 602
        return 0
    }

    // 获取+按钮的位置X
    private GetAddBtnX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 392
        else if (screenW === 1280 && screenH === 720) return 492
        else if (screenW === 540 && screenH === 960) return 188
        return 0
    }

    // 获取+按钮的位置Y
    private GetAddBtnY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 284
        else if (screenW === 1280 && screenH === 720) return 379
        else if (screenW === 540 && screenH === 960) return 530
        return 0
    }

    // 获取-按钮的位置X
    private GetMinBtnX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 298
        else if (screenW === 1280 && screenH === 720) return 398
        else if (screenW === 540 && screenH === 960) return 94
        return 0
    }

    // 获取-按钮的位置Y
    private GetMinBtnY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 284
        else if (screenW === 1280 && screenH === 720) return 379
        else if (screenW === 540 && screenH === 960) return 530
        return 0
    }

    // 获取商品详情页购买数量的X坐标
    private GetBuyCountX() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 352
        else if (screenW === 1280 && screenH === 720) return 452
        else if (screenW === 540 && screenH === 960) return 148
        return 0
    }

    // 获取商品详情页购买数量的Y坐标
    private GetBuyCountY() {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW === 960 && screenH === 540) return 283
        else if (screenW === 1280 && screenH === 720) return 378
        else if (screenW === 540 && screenH === 960) return 529
        return 0
    }

    readVersionedOui(reader: FileReader, dataVersion: number, IsUI = false): void {
        this.Version = reader.readInt()
        this.MallBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.DecorateBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.Decorate_X = reader.readInt()
        this.Decorate_Y = reader.readInt()
        this.IsUseOaf = Boolean(reader.readInt())
        this.OafDetailInfo.readVersionedOui(reader.readObj(reader.readInt()))
        this.ClosePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()
        this.FlowerOwn_X = reader.readInt()
        this.FlowerOwn_Y = reader.readInt()
        this.FlowerPrice_X = reader.readInt()
        this.FlowerPrice_Y = reader.readInt()

        this.GoodDetailPage.readVersionedOui(reader.readObj(reader.readInt()))

        this.GoodAreaBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodAreaBack_X = reader.readInt()
        this.GoodAreaBack_Y = reader.readInt()
        this.GoodAreaBack_W = reader.readInt()
        this.GoodAreaBack_H = reader.readInt()

        this.IsShowGoodName = Boolean(reader.readInt())
        this.IsShowGoodIntro = Boolean(reader.readInt())
        this.IsShowGoodImage = Boolean(reader.readInt())

        const goodsListLen = reader.readInt()

        this.GoodsList = []
        for (let i = 0; i < goodsListLen; i++) {
            const goods = new Goods()
            goods.readVersionedOui(reader.readObj(reader.readInt()))
            this.GoodsList.push(goods)
        }

        if (!IsUI && dataVersion >= 106) {
            try {
                this.PrePic.readVersionedOui(reader.readObj(reader.readInt()))
            } catch {
                this.PrePic = new AvgButtonIndex(0, 0, 0)
            }

            try {
                this.NextPic.readVersionedOui(reader.readObj(reader.readInt()))
            } catch {
                this.NextPic = new AvgButtonIndex(0, 0, 0)
            }

            try {
                this.PageFont.readVersionedOui(reader.readObj(reader.readInt()))
            } catch {
                this.PageFont = new FontProperty('', 14, '')
            }

            try {
                this.PageX = reader.readInt()
            } catch {}

            try {
                this.PageY = reader.readInt()
            } catch {}

            try {
                this.TagButton.readVersionedOui(reader.readObj(reader.readInt()))
            } catch {
                this.TagButton = new AvgButtonIndex(0, 0, 0)
            }

            try {
                this.TagName = reader.readString()
            } catch {}

            let cnt = 0

            if (!reader.isReadEnd()) {
                cnt = reader.readInt()
            }

            for (let i = 0; i < goodsListLen; i++) {
                if (!reader.isReadEnd() && i < cnt) {
                    this.GoodsList[i].GoodsPricePakoras = reader.readInt()
                } else {
                    this.GoodsList[i].GoodsPricePakoras = 0
                }
            }

            if (!reader.isReadEnd()) {
                this.PublishTime = reader.readString()
            }

            if (!reader.isReadEnd()) {
                this.ModifyPosition = reader.readInt()
            }

            if (!reader.isReadEnd()) {
                this.IsShowOneKeyGetBtn = Boolean(reader.readInt())
            } else {
                this.IsShowOneKeyGetBtn = true
            }
            try {
                if (!reader.isReadEnd()) {
                    this.OneKeyGetBtn.readVersionedOui(reader.readObj(reader.readInt()))
                }
            } catch (error) {
                this.OneKeyGetBtn = new AvgButtonIndex(0, 0, 0)
            }
            try {
                if (!reader.isReadEnd()) {
                    this.FontInfo.readVersionedOui(reader.readObj(reader.readInt()))
                }
            } catch (error) {
                this.FontInfo = new FontProperty('微软雅黑', 20, '255,255,255')
            }
        }
    }


    writeVersionedOui(writer: FileWriter, IsUI = false): void {
        writer.writeInt(this.Version)
        this.MallBack.writeVersionedOui(writer)
        this.DecorateBack.writeVersionedOui(writer)
        writer.writeInt(this.Decorate_X)
        writer.writeInt(this.Decorate_Y)
        writer.writeInt(this.IsUseOaf ? 1 : 0)
        this.OafDetailInfo.writeVersionedOui(writer)
        this.ClosePic.writeVersionedOui(writer)
        this.FlowerFont.writeVersionedOui(writer)
        this.FlowerPic.writeVersionedOui(writer)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.FlowerOwn_X)
        writer.writeInt(this.FlowerOwn_Y)
        writer.writeInt(this.FlowerPrice_X)
        writer.writeInt(this.FlowerPrice_Y)

        this.GoodDetailPage.writeVersionedOui(writer)
        this.GoodAreaBack.writeVersionedOui(writer)
        writer.writeInt(this.GoodAreaBack_X)
        writer.writeInt(this.GoodAreaBack_Y)
        writer.writeInt(this.GoodAreaBack_W)
        writer.writeInt(this.GoodAreaBack_H)

        writer.writeInt(this.IsShowGoodName ? 1 : 0)
        writer.writeInt(this.IsShowGoodIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodImage ? 1 : 0)

        if (this.GoodsList.length) {
            writer.writeInt(this.GoodsList.length)
            for (let i = 0; i < this.GoodsList.length; i++) {
                const goods = this.GoodsList[i]
                goods.writeVersionedOui(writer)
            }
        } else {
            writer.writeInt(0)
        }

        if (!IsUI) {
            this.PrePic.writeVersionedOui(writer)
            this.NextPic.writeVersionedOui(writer)
            this.PageFont.writeVersionedOui(writer)
            writer.writeInt(this.PageX)
            writer.writeInt(this.PageY)

            this.TagButton.writeVersionedOui(writer)

            writer.writeString(this.TagName)

            if (this.GoodsList.length > 0) {
                writer.writeInt(this.GoodsList.length)
                for (let i = 0; i < this.GoodsList.length; i++) {
                    writer.writeInt(this.GoodsList[i].GoodsPricePakoras)
                }
            }
            writer.writeString(this.PublishTime)
            writer.writeInt(this.ModifyPosition)
            writer.writeInt(this.IsShowOneKeyGetBtn ? 1 : 0)
            this.OneKeyGetBtn = this.OneKeyGetBtn ?? new AvgButtonIndex(0, 0, 0)
            this.OneKeyGetBtn.writeVersionedOui(writer)
            this.FontInfo.writeVersionedOui(writer)
        }
    }

    readMallBin(reader: FileReader): void {
        this.Version = reader.readInt()
        this.MallBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.DecorateBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.Decorate_X = reader.readInt()
        this.Decorate_Y = reader.readInt()
        this.IsUseOaf = Boolean(reader.readInt())
        this.OafDetailInfo.readVersionedOui(reader.readObj(reader.readInt()))
        this.ClosePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()
        this.FlowerOwn_X = reader.readInt()
        this.FlowerOwn_Y = reader.readInt()
        this.FlowerPrice_X = reader.readInt()
        this.FlowerPrice_Y = reader.readInt()
        this.GoodDetailPage.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodAreaBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodAreaBack_X = reader.readInt()
        this.GoodAreaBack_Y = reader.readInt()
        this.GoodAreaBack_W = reader.readInt()
        this.GoodAreaBack_H = reader.readInt()
        this.IsShowGoodName = Boolean(reader.readInt())
        this.IsShowGoodIntro = Boolean(reader.readInt())
        this.IsShowGoodImage = Boolean(reader.readInt())

        const goodsListLen = reader.readInt()
        this.GoodsList = []
        for (let i = 0; i < goodsListLen; i++) {
            const goods = new Goods()
            goods.readVersionedOui(reader.readObj(reader.readInt()))
            this.GoodsList.push(goods)
        }

        this.PrePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.NextPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.PageFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.PageX = reader.readInt()
        this.PageY = reader.readInt()
        this.TagButton.readVersionedOui(reader.readObj(reader.readInt()))
        this.TagName = reader.readString()

        const goodsPriceCount = reader.readInt()
        for (let i = 0; i < this.GoodsList.length; i++) {
            this.GoodsList[i].GoodsPricePakoras = i < goodsPriceCount ? reader.readInt() : 0
        }

        this.PublishTime = reader.readString()
        this.ModifyPosition = reader.readInt()
        this.IsShowOneKeyGetBtn = Boolean(reader.readInt())
        this.OneKeyGetBtn.readVersionedOui(reader.readObj(reader.readInt()))
    }

    writeMallBin(writer: FileWriter): void {
        writer.writeInt(this.Version)
        this.MallBack.writeMallBin(writer)
        this.DecorateBack.writeMallBin(writer)
        writer.writeInt(this.Decorate_X)
        writer.writeInt(this.Decorate_Y)
        writer.writeInt(this.IsUseOaf ? 1 : 0)
        this.OafDetailInfo.writeMallBin(writer)
        this.ClosePic.writeMallBin(writer)
        this.FlowerFont.writeMallBin(writer)
        this.FlowerPic.writeMallBin(writer)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.FlowerOwn_X)
        writer.writeInt(this.FlowerOwn_Y)
        writer.writeInt(this.FlowerPrice_X)
        writer.writeInt(this.FlowerPrice_Y)
        this.GoodDetailPage.writeMallBin(writer)
        this.GoodAreaBack.writeMallBin(writer)
        writer.writeInt(this.GoodAreaBack_X)
        writer.writeInt(this.GoodAreaBack_Y)
        writer.writeInt(this.GoodAreaBack_W)
        writer.writeInt(this.GoodAreaBack_H)
        writer.writeInt(this.IsShowGoodName ? 1 : 0)
        writer.writeInt(this.IsShowGoodIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodImage ? 1 : 0)
        writer.writeInt(this.GoodsList.length)
        for (const goods of this.GoodsList) {
            goods.writeMallBin(writer)
        }
        this.PrePic.writeMallBin(writer)
        this.NextPic.writeMallBin(writer)
        this.PageFont.writeMallBin(writer)
        writer.writeInt(this.PageX)
        writer.writeInt(this.PageY)
        this.TagButton.writeMallBin(writer)
        writer.writeString(this.TagName)
        writer.writeInt(this.GoodsList.length)
        for (const goods of this.GoodsList) {
            writer.writeInt(goods.GoodsPricePakoras)
        }
        writer.writeString(this.PublishTime)
        writer.writeInt(this.ModifyPosition)
        writer.writeInt(this.IsShowOneKeyGetBtn ? 1 : 0)
        this.OneKeyGetBtn = this.OneKeyGetBtn ?? new AvgButtonIndex(0, 0, 0)
        this.OneKeyGetBtn.writeMallBin(writer)
    }
}
export default GameMallNewModel
